/**
 * In-section notice visibility — report PAGE vs delivered artifact.
 *
 * William, 2026-10-13: "i dont want any banners on report pages" — including
 * the notes that render INSIDE report sections (SectionQuarantineBanner, the
 * report / inline WithheldNarrativeNotice, the admin MetaLeakChip). Those
 * notes are ALSO part of the delivered artifact: the PDF / print tree renders
 * this same view with viewMode 'export', and the export content must not
 * change. So the notes read this context instead of being deleted:
 *
 *   - SiteRagReportView provides `visible={false}` for the interactive page
 *     (editor / reader audiences). The header status chip and the ⋮ "Section
 *     quality notes" dialog carry the same information there.
 *   - The export tree and the public share (a delivered copy) provide `true`.
 *   - Every other host — the Analyses tab, the Template Studio, standalone
 *     component mounts — has no provider and keeps the default (`true`), so
 *     its output is byte-identical to before.
 */
import React from 'react';

const InSectionNoticesContext = React.createContext<boolean>(true);

export function InSectionNoticesProvider({
  visible,
  children,
}: {
  visible: boolean;
  children: React.ReactNode;
}): React.ReactElement {
  return <InSectionNoticesContext.Provider value={visible}>{children}</InSectionNoticesContext.Provider>;
}

/** False only on the interactive report page. */
export function useInSectionNoticesVisible(): boolean {
  return React.useContext(InSectionNoticesContext);
}
